import { useSelector } from 'react-redux'

import { isShadow } from 'store/user'

const useIsShadow = () => {
  return useSelector((store) => isShadow(store))
}

export default useIsShadow
